import React from 'react'

import './_field-note.scss'

import cn from '../../libs/class-names'

import {CommonProps, Overwrite} from '../../types'

type Props = Overwrite<
  CommonProps<'div'>,
  {
    children: React.ReactNode
    note?: React.ReactNode
    appearance?: 'base' | 'warning' | 'minor' | 'error' | 'success'
  }
>

const FieldNote = ({className, children, note, appearance = 'base', ...props}: Props) => (
  <div
    {...props}
    className={cn('FieldNote', {[`appearance-${appearance}`]: !!appearance}, className)}
  >
    {children}
    {note && <div className="FieldNote__note">{note}</div>}
  </div>
)

export default FieldNote
